import type { InternalCookieOptions } from './types';
import { getExpiresInMonths, setCookie } from './utils';

const COOKIE_NAME = 'stbg';

const normalizeGender = (gender: string): string =>
  ['M', 'F'].includes(gender.toUpperCase()) ? gender.toLowerCase() : 'x';

/** Sets the `stbg` (gender) cookie. */
export const writeGenderCookie = (
  gender: string,
  options: InternalCookieOptions,
): void => {
  setCookie(
    COOKIE_NAME,
    normalizeGender(gender),
    options,
    getExpiresInMonths(1),
  );
};
